import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CardSelectionItem } from '@shared/ui/card-selection-item/card-selection-item';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuCard } from '@shared/interfaces/menu.interface';


@Component({
  selector: 'app-nav-bar-menu',
  imports: [CardSelectionItem, TranslatePipe],
  templateUrl: './nav-bar-menu.html',
  styleUrls:[]
})
export class NavBarMenu {
  @Input() cards: MenuCard[] = [];
  @Input() cardView: 'default' | 'small' = 'default';
  @Output() cardSelected = new EventEmitter<{link: string, title: string}>();

  onCardSelected(event: {link: string, title: string}) {
    this.cardView = 'small';
    this.cardSelected.emit(event);
  }

  trackByTitle(index: number, card: MenuCard) {
    return card.title;
  }
}
